import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoFixedQualityQpInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoFixedQualityQpInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
   const [ qp, setQp ] = useState<number>(project.encoder.transcoderVideoFixedQualityQp);
  const debounce = 100;
  const min = 17;
  const max = 28;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = qp;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setQp(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoFixedQualityQp: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoFixedQualityQp: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setQp(project.encoder.transcoderVideoFixedQualityQp);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.transcoderVideoFixedQualityQp]);

  return (
    <div className="video-fixed-quality-qp-input">
      <div className="input-title">
        {t('producer.inputs.video-fixed-quality-qp.title')}
        <Help
          title="Fixed Quality QP"
          text="Fixed Quality QP sets a constant compression level for your video stream.<br/><br/>- Lower QP values produce higher quality video but increase file size.<br/>- Higher QP values reduce file size but may decrease visual quality, especially in detailed or fast-moving scenes.<br/>- Use this setting if you want a predictable level of compression for your stream.<br/><br/>This option maintains a consistent compression ratio rather than varying bitrate."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.video-fixed-quality-qp.placeholder"
        value={qp.toString()}
        onChange={(value) => {setQp(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">
        {t('producer.inputs.video-fixed-quality-qp.footer')}
      </div>
    </div>
  );
};

export default React.memo(VideoFixedQualityQpInput);
